// Copyright (c) Move Closer 2022.

import { Component, Vue } from 'vue-property-decorator'

import { Inject } from '../../../support'

import { IToastsService, ToastsServiceType, ToastType } from '../services'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface IToastMixin {
  showToast (content: string, type: 'danger' | 'info' | 'success' | 'warning'): void
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
@Component
export class ToastMixin extends Vue implements IToastMixin {
  @Inject(ToastsServiceType, false)
  private readonly toastService?: IToastsService

  public showToast (content: string, type: 'danger' | 'info' | 'success' | 'warning'): void {
    if (typeof this.toastService === 'undefined') {
      return
    }

    this.toastService.show(content, type as ToastType)
  }
}
